import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyL, BrandM, BrandXXL } from '#src/atoms/typography/index.tsx';
import { Img } from '#src/atoms/ui/Img/index.tsx';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

import mobileRewards from './assets/mobileRewards.webp';
import webBackground from './assets/webBackground.webp';

const Root = styled(Vertical)`
  padding: var(--double-unit);
  @media ${laptopAndAbove} {
    flex-direction: row;
    gap: calc(var(--unit) * 10);
    padding: calc(var(--unit) * 15) calc(var(--unit) * 10);
    align-items: flex-start;
    justify-content: flex-end;
    min-height: calc(var(--unit) * 125);
    background-image: url(${webBackground});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const ImageContainer = styled.div`
  @media ${laptopAndAbove} {
    width: 50%;
  }
`;

const TextContainer = styled(Vertical).attrs({
  gap: 6,
  center: true,
})`
  @media ${laptopAndAbove} {
    width: 50%;
    padding: 100px 0;
  }
`;

export const WinRewards = () => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Root id="HowToPlay.navbar.win-rewards">
      <TextContainer>
        <Vertical gap={4}>
          <Vertical gap={2}>
            <BrandM uppercase color="var(--c-limited)">
              <FormattedMessage
                id="HowToPlay.WinRewards.eyebrow"
                defaultMessage="How to win rewards"
              />
            </BrandM>
            <BrandXXL uppercase>
              <FormattedMessage
                id="HowToPlay.WinRewards.title"
                defaultMessage="Rewards all season long"
              />
            </BrandXXL>
          </Vertical>
          <BodyL>
            <FormattedMessage
              id="HowToPlay.WinRewards.description"
              defaultMessage="Sorare competitions offer new rewards throughout the season,
so <b>it's never too late to join and win.</b>"
              values={{
                b: chunks => <strong>{chunks}</strong>,
              }}
            />
          </BodyL>
        </Vertical>
      </TextContainer>
      {!isLaptopAndAbove && (
        <ImageContainer>
          <Img src={mobileRewards} width={705} height={1127} alt="" />
        </ImageContainer>
      )}
    </Root>
  );
};
